$vGutterLargeDesktop: 48px;
$vGutterDesktop: 40px;
$vGutterTablet: 32px;
$vGutterPhone: 24px;

$hGutterLargeDesktop: 48px;
$hGutterDesktop: 40px;
$hGutterTablet: 32px;
$hGutterPhone: 24px;

$outerSpacingMobile: 24px;

$content-aggregator-drop-shadow: none !default;
$content-aggregator-drop-shadow-on-hover: none !default;

/* Function calculates column width */
@mixin calc-column-percentage($columnNumber, $maxColumnNumber) {
  width: customDivide(($columnNumber * 100%), $maxColumnNumber);
  flex-basis: calc(
    (#{$columnNumber} * 100% / #{$maxColumnNumber}) - 1px
  ); /* has to be set because of safari 13.x bug (solved in safari 14.x) */
}

/* Function generates width in percent per each column */
@mixin generate-column-width($n, $i: 1) {
  @if ($i <= $n) {
    @at-root &.#{$prefix}grid-column-#{$i} {
      width: customDivide(($i * 100%), $n);
      flex-basis: calc(
        (#{$i} * 100% / #{$n}) - 1px
      ); /* has to be set because of safari 13.x bug (solved in safari 14.x) */
    }
    @include generate-column-width($n, ($i + 1));
  }
}

:host {
  display: block;
}
// apply pfx
.#{$prefix}news-teaser-container {
  display: flex;

  &.#{$prefix}list-layout {
    flex-direction: column;
    .#{$prefix}news-teaser-item {
      padding-bottom: 8px;
    }
  }

  &.#{$prefix}tile-layout {
    display: block;

    * {
      margin: 0;
      padding: 0;
    }

    *,
    *::after,
    *::before {
      box-sizing: border-box;
      outline: 0 none;
      text-rendering: optimizelegibility;
    }

    .#{$prefix}news-teaser-grid__control {
      display: flex;
      flex-wrap: wrap;

      &[data-visible="false"] {
        display: none;
      }

      &__last {
        .#{$prefix}news-teaser-grid__column {
          padding-bottom: 0 !important;
        }
      }

      .#{$prefix}news-teaser-grid__column {
        position: relative;
        flex-grow: 1;
        flex-shrink: 1;
        padding-left: $vGutterLargeDesktop * 0.5;
        padding-right: $vGutterLargeDesktop * 0.5;
        padding-bottom: $hGutterLargeDesktop;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }

        @include for-size(desktop) {
          padding-bottom: $hGutterDesktop;
          padding-left: $vGutterDesktop * 0.5;
          padding-right: $vGutterDesktop * 0.5;
        }

        @include for-size(tablet) {
          padding-bottom: $hGutterTablet;
          padding-left: $vGutterTablet * 0.5;
          padding-right: $vGutterTablet * 0.5;
        }

        @include for-size(phone) {
          padding-bottom: $hGutterPhone * 0.5;
          padding-left: $vGutterPhone * 0.5;
          padding-right: $vGutterPhone * 0.5;
          width: 100%;
          flex-basis: calc(100% - 1px);
        }

        @include generate-column-width(12);
      }
    }

    @include for-size(phone) {
      transform: translateX((-#{$outerSpacingMobile}));
      width: calc(100% + #{$outerSpacingMobile} * 2);
      position: relative;
    }

    .#{$prefix}news-teaser-paging {
      padding-top: $hGutterLargeDesktop;

      @include for-size(desktop) {
        padding-top: $hGutterDesktop;
      }

      @include for-size(tablet) {
        padding-top: $hGutterTablet;
      }

      @include for-size(phone) {
        padding-top: $hGutterPhone;
        padding-left: $vGutterPhone;
        padding-right: $vGutterPhone;
      }

      &__column {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;

        @include for-size(phone) {
          display: block;
        }
      }
    }
  }

  .#{$prefix}news-teaser-item {
    flex-grow: 1;
    flex-basis: 0;
  }
}

eon-ui-content-aggregator-item[variant="list_expanded"] {
  margin: 20px 0;

  @include for-size(desktop) {
    margin: 20px 0;
  }

  @include for-size(tablet) {
    margin: 15px 0;
  }

  @include for-size(phone) {
    margin: 10px 0;
  }
}
